// Canvas-based image cropping shared by the post composer (PhotoEditorModal)
// and the vehicle cover-photo editor (ThumbnailCropModal).

// Aspect ratio of a vehicle card cover. Matches the app garage card
// (aspectRatio 4/3); web cards use object-fit: cover so the framed subject
// stays centered regardless of the exact card box.
export const COVER_ASPECT = 4 / 3;

export function createImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    // Allow cropping remote (R2) images on a canvas without tainting it.
    img.crossOrigin = 'anonymous';
    img.src = url;
  });
}

// Crop the given image to `pixelCrop` ({ x, y, width, height } in source pixels,
// as produced by react-easy-crop's onCropComplete) and return a JPEG File.
export async function getCroppedImg(url, pixelCrop, fileName = 'photo.jpg') {
  const image = await createImage(url);
  const canvas = document.createElement('canvas');
  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(
    image,
    pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
    0, 0, pixelCrop.width, pixelCrop.height
  );
  return new Promise(resolve =>
    canvas.toBlob(
      blob => resolve(new File([blob], fileName, { type: 'image/jpeg' })),
      'image/jpeg', 0.92
    )
  );
}
